{
    "coordinates": [
        -7.429970554254552,
        -75.01857668419385
    ],
    "tooltip": "Pebas",
    "title": "Pebas Formation",
    "country": "Brazil, Colombia, Ecuador, Peru",
    "period": "Neogene",
    "alt": "TODO"
}
